$(function() {
 // 以下為Swiper設定

  // 共用Auto 
  var auplayFun = {
    delay: 3500,
    //stopOnLastSlide: false,
    disableOnInteraction: false,
  }

  // 進場動畫
  var pageFun = function(){
    var percent = 0;
    var timer = setInterval(function () {
      $(".bar").css("width", percent + "%");
      percent += 1;

      if (percent > 100) {
        clearInterval(timer);
        
        // 載完loading就把className拿掉...
        $('.js-loadHide').removeClass('js-loadHide');
        $(".pageloading").addClass("compelet");

        setTimeout(function () {
          bannerSwiper.params.autoplay = auplayFun;
          bannerSwiper.autoplay.start();
        },0);
      }
    }, 0);
  }

  if($('.bannerSwiper').length > 0) {
    // 首頁Banner
    var bannerSwiper = new Swiper('.bannerSwiper .swiper-container', {
      autoplay: auplayFun,
      // parallax: true,
      keyboard : true,
      virtualTranslate : true,
      effect: 'coverflow',
      
      on:{
        setTranslate: function(){
          this.$wrapperEl.transition('')
          TweenMax.to(this.$wrapperEl, 1.5, {x:this.translate, ease:Power4.easeOut})
        }
      },

      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
    });

    bannerSwiper.autoplay.stop();
    pageFun();
  }

  // 首頁產品
  var swiper = new Swiper(".index-pagePro-swiper .mySwiper", {
    // loop: true,
    speed: 1000,
    autoplay: auplayFun,
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides: true,
    // centeredSlidesBounds: true,
    navigation: {
      nextEl: ".index-pagePro-swiper .swiper-button-next",
      prevEl: ".index-pagePro-swiper .swiper-button-prev",
    },
    pagination: {
      el: '.index-pagePro-swiper .swiper-pagination',
      clickable: true,
    },
    
    breakpoints: { 
      320: {  //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      },
      
      768: {  //当屏幕宽度大于等于768
        slidesPerView: 3,
        spaceBetween: 0,
      }
    }
  });

  const swiperTitle = new Swiper('.index-pagePro-swiper .swiper-slide-intro-box',{
    // loop: true,
    direction: "vertical",
    centeredSlides: true,
    // centeredSlidesBounds: true,
  });

  swiper.controller.control = swiperTitle;
  swiperTitle.controller.control = swiper;
  

  // 產品詳細
  var Prod_mySwiper = new Swiper(".Prod-photo-small .Prod_mySwiper", {
    // autoplay: auplayFun,
    autoplay:false,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: { 
      320: {  //当屏幕宽度大于等于320
        slidesPerView: 3,
        spaceBetween: 5,
      },
      760: {  //当屏幕宽度大于等于760
        slidesPerView: 4,
        spaceBetween: 5,
      }
    }
  });

  var Prod_mySwiper2 = new Swiper(".Prod-photo .Prod_mySwiper2", {
    // autoplay: auplayFun,
    autoplay:false,
    speed: 1000,
    spaceBetween: 10,
    navigation: {
      nextEl: ".Prod-photo .swiper-button-next",
      prevEl: ".Prod-photo .swiper-button-prev",
    },
    thumbs: {
      swiper: Prod_mySwiper,
    },
  });

  // 以下為Gotop
  $(".float-link .link-btn.top, .float-link .link-btn.mobile-top").on('click',function () {
    $("html,body").animate({ "scrollTop": "0" })
  });

  $(window).on("load resize scroll", function (e) {
    var scroll = $(this).scrollTop();
    var wdh = $(window).height();
    if (scroll > 50) {
        $(".float-link").addClass("active");
    } else {
        $(".float-link").removeClass("active");
    }
  });

  // 左側分類
  toggleFun('.js-toggle-btn','.js-toggle')

  // 產品側邊選單
  var $slidemenu = $(".link-wrap.pro ul > li > a.first_menu_link");
  $slidemenu.on('click', function () {
    // 點擊當前項目才打開
    var serToggle = $(this).closest('li').find(".first_menu");
    $(".first_menu").not(serToggle).removeClass('open');
    $slidemenu.not($(this)).removeClass('active');

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      serToggle.removeClass('open');
    } else {
      $(this).addClass('active');
      serToggle.addClass('open');
    }

    e.stopPropagation();
  });

  // 產品側邊選單-下一層
  var $slidemenuSecond = $(".first_menu_li > a");
  $slidemenuSecond.on('click',function(){
    // 點擊當前項目才打開
    var serToggleSecond = $(this).closest('li').find(".second_menu");
    $(".second_menu").not(serToggleSecond).removeClass('active');
    $slidemenuSecond.not($(this)).removeClass('active');

    if($(this).hasClass('active')){
      $(this).removeClass('active');
      serToggleSecond.removeClass('active');
    }else{
      $(this).addClass('active');
      serToggleSecond.addClass('active');
    }
  });

  // 
  var $navbarmenu = $(".navbarMobile-toggle > li .nav-mobileBtn");
  $navbarmenu.on('click', function (e) {
    let curNext = $(this).next();
    $('.navbar_first_menu').not(curNext).removeClass('active');
    $(this).next().toggleClass('active');

    e.stopPropagation();
  });
   
  // BS navbar-collapse show / hidden
  $('.navbar-toggler').on('click',function(){
    $('.navbar-overlay, .navbar-toggler.fixed').addClass('active')
  })

  $('#js-navbarToggle-fixed').on('click', function () {
    $('#navbar-content').removeClass('show');
    $('.navbar-overlay, .navbar-toggler.fixed').removeClass('active')
  });

   // 以下為 Cookies
   $(".close-cookies").on('click',function(e) {
    e.preventDefault();
    $(".cookies").addClass("close-cookies");
  });

  // input focus & filter
  $("#navbarSearch").on('focus',function() {
    $(".navbar-searchFilter").addClass("open");
  })// .on('blur',function() {
  //   $(".navbar-searchFilter").removeClass("open");
  // });

  $("#navbarSearch-btn").on('click',function() {
    $(".navbar-searchFilter").addClass("open");
  })// .on('blur',function() {
  //   $(".navbar-searchFilter").removeClass("open");
  // });

  $('.navbar-searchFilter-close').on('click',function(){
    $(".navbar-searchFilter").removeClass("open");
  })

  // 文字點點點
  checkEllipsis('.index-card-text',100);

});

function resize() {
  var winHeight = $(window).height();
  $(".modal-autoheight .modal-body").css({
    width: "auto",
    height: (winHeight - 200) + "px"
  });
}

function btnScroll($name){
  $($name).on('click',function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
      if ($target.length) {
        var targetOffset = $target.offset().top - 75;
        $('html,body').animate({ scrollTop: targetOffset }, 1000);
        return false;
      }
    }
  });
}

// 取得頁面寬度
function viewport() {
  var e = window,
      a = 'inner';
  if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
  }
  return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

// Toggle Fun
function toggleFun(item,status){
  $(item).on('click',function() {
    $(status).toggleClass('js-open');
    return false;
  });
}

// 文字點點點
function checkEllipsis(name,len){
  $(name).each(function(i){
    if($(this).text().length>len){
        $(this).attr("title",$(this).text());
        let text=$(this).text().substring(0,len-1)+"...";
        $(this).text(text);
    }
  });
}
